// Cart Reliability Fixes (non-invasive)
// Never call getToFetch() — it replaces DOM and can cause reload loops.
// Only clear stuck visual states and ensure drawer opens after ATC.

(function() {
  'use strict';

  var _recoveryInFlight = {
    't4s-mini_cart': false,
    't4s-login-sidebar': false
  };
  var _lastRecoveryTs = {
    't4s-mini_cart': 0,
    't4s-login-sidebar': 0
  };

  function isDrawerOpen() {
    if (document.documentElement.classList.contains('is--opend-drawer')) return true;
    return !!document.querySelector('#t4s-mini_cart[aria-hidden="false"], #t4s-login-sidebar[aria-hidden="false"]');
  }

  function openCartDrawerAfterSuccess() {
    document.addEventListener('add:cart:success', function() {
      setTimeout(function() {
        var drawerSetting = window.T4Sconfigs && window.T4Sconfigs.after_action_atc;
        if (drawerSetting !== '3') return;
        if (!(window.T4SThemeSP && T4SThemeSP.Drawer)) return;

        var miniCart = document.getElementById('t4s-mini_cart');
        if (miniCart) {
          T4SThemeSP.Drawer.opend(miniCart);
        }
      }, 150);
    });
  }

  function forceUnstick(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is--contentUpdate');

    var items = drawer.querySelector('[data-cart-items]');
    if (items) {
      items.style.opacity = '';
      items.style.visibility = '';
    }
    var bottom = drawer.querySelector('.t4s-drawer__bottom');
    if (bottom) {
      bottom.style.opacity = '1';
      bottom.style.transform = 'none';
    }
  }

  function getOpenDrawer() {
    var ids = ['t4s-mini_cart', 't4s-login-sidebar'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && el.getAttribute('aria-hidden') === 'false') return el;
    }
    return null;
  }

  function isMiniCartStuck(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains('is--contentUpdate')) return true;

    var skeletonCount = drawer.querySelectorAll('.t4s-skeleton-element').length;
    var hasHydratedContent = !!drawer.querySelector('[data-cart-items], .mc26-summary');
    if (skeletonCount > 3 && !hasHydratedContent) return true;

    var items = drawer.querySelector('[data-cart-items]');
    if (items) {
      var s = window.getComputedStyle(items);
      if (s.visibility === 'hidden' || s.opacity === '0') return true;
    }
    return false;
  }

  function isLoginDrawerStuck(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains('is--contentUpdate')) return true;

    var skeletonCount = drawer.querySelectorAll('.t4s-skeleton-element').length;
    var hasHydratedContent = !!drawer.querySelector('.t4s-content-login-sidebar, form[action*="/account/login"], #CustomerEmail');
    return skeletonCount > 2 && !hasHydratedContent;
  }

  function hydrateDrawerFromSection(drawerId, sectionId, onHydrated) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return Promise.resolve(false);

    var now = Date.now();
    if (_recoveryInFlight[drawerId]) return Promise.resolve(false);
    if (now - (_lastRecoveryTs[drawerId] || 0) < 1500) return Promise.resolve(false);

    _recoveryInFlight[drawerId] = true;
    _lastRecoveryTs[drawerId] = now;

    var sectionUrl = '?section_id=' + sectionId + '&_ts=' + now;
    return fetch(sectionUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Section fetch failed (' + r.status + ')');
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var freshRoot = tmp.querySelector('#' + drawerId);
        drawer.innerHTML = freshRoot ? freshRoot.innerHTML : tmp.innerHTML;
        forceUnstick(drawer);
        if (typeof onHydrated === 'function') onHydrated();
        return true;
      })
      .catch(function (err) {
        console.warn('[Drawer Safety] Rehydrate failed for', drawerId, err && err.message ? err.message : err);
        return false;
      })
      .finally(function () {
        _recoveryInFlight[drawerId] = false;
      });
  }

  function recoverOpenDrawerIfStuck() {
    var drawer = getOpenDrawer();
    if (!drawer) return;

    if (drawer.id === 't4s-mini_cart' && isMiniCartStuck(drawer)) {
      hydrateDrawerFromSection('t4s-mini_cart', 'mini_cart', function () {
        try {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (typeof jQuery !== 'undefined') jQuery(document).trigger('cart:updated');
        } catch (e) {}
      });
      return;
    }

    if (drawer.id === 't4s-login-sidebar' && isLoginDrawerStuck(drawer)) {
      hydrateDrawerFromSection('t4s-login-sidebar', 'login-sidebar', function () {
        if (window.T4SThemeSP && typeof T4SThemeSP.Login === 'function') {
          try { T4SThemeSP.Login(); } catch (e) {}
        }
      });
    }
  }

  function skeletonWatchdog() {
    var watchTimer = null;
    var drawerWasOpen = false;
    var fastCheckTimer = null;
    var midCheckTimer = null;
    var slowCheckTimer = null;

    function clearWatchTimers() {
      clearTimeout(watchTimer);
      clearTimeout(fastCheckTimer);
      clearTimeout(midCheckTimer);
      clearTimeout(slowCheckTimer);
    }

    function onDrawerOpen() {
      clearWatchTimers();
      // Fast pass for first-load quick opens where users can see skeleton lock.
      fastCheckTimer = setTimeout(function () {
        if (!isDrawerOpen()) return;
        recoverOpenDrawerIfStuck();
      }, 900);

      // Mid pass catches slower mini-cart section hydration races.
      midCheckTimer = setTimeout(function () {
        if (!isDrawerOpen()) return;
        recoverOpenDrawerIfStuck();
      }, 2200);

      // Final pass for long-tail delays.
      slowCheckTimer = setTimeout(function () {
        if (!isDrawerOpen()) return;
        recoverOpenDrawerIfStuck();
      }, 4200);
    }

    function onDrawerClose() {
      clearWatchTimers();
    }

    new MutationObserver(function () {
      var open = isDrawerOpen();
      if (open && !drawerWasOpen) { drawerWasOpen = true; onDrawerOpen(); }
      else if (!open && drawerWasOpen) { drawerWasOpen = false; onDrawerClose(); }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    function watchDrawerAria(drawerId) {
      var drawer = document.getElementById(drawerId);
      if (!drawer || drawer._ddAriaWatchBound) return;
      drawer._ddAriaWatchBound = true;
      new MutationObserver(function () {
        var open = drawer.getAttribute('aria-hidden') === 'false';
        if (open) {
          drawerWasOpen = true;
          onDrawerOpen();
        } else if (drawerWasOpen) {
          drawerWasOpen = false;
          onDrawerClose();
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    watchDrawerAria('t4s-mini_cart');
    watchDrawerAria('t4s-login-sidebar');

    // Bootstrap guard: if the drawer opened before this watcher attached
    // (first-load race), run the same open workflow immediately.
    if (isDrawerOpen() || getOpenDrawer()) {
      drawerWasOpen = true;
      onDrawerOpen();
    }

    // If cart updates while a drawer is open, re-check for stuck skeleton state.
    document.addEventListener('cart:updated', function () {
      if (!getOpenDrawer()) return;
      setTimeout(recoverOpenDrawerIfStuck, 1200);
    });
    // Fired by mini-cart code when a cart-open refresh path runs.
    document.addEventListener('cart:refresh:opend', function () {
      clearTimeout(watchTimer);
      watchTimer = setTimeout(recoverOpenDrawerIfStuck, 900);
    });
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('cart:updated', function () {
        if (!getOpenDrawer()) return;
        setTimeout(recoverOpenDrawerIfStuck, 1200);
      });
    }
  }

  function stockLimitToastGuard() {
    var _lastToastTs = 0;
    var _lastToastKey = '';

    function toInt(v) {
      var n = parseInt(v, 10);
      return isNaN(n) ? 0 : n;
    }

    function inCartContext(el) {
      return !!(
        el &&
        (
          el.closest('#t4s-mini_cart') ||
          el.closest('.t4s-main-cart') ||
          el.closest('[data-cart-item]')
        )
      );
    }

    function showStockLimitToast(maxQty, key) {
      var now = Date.now();
      var dedupeKey = String(key || 'cart-stock');
      if (now - _lastToastTs < 1200 && _lastToastKey === dedupeKey) return;
      _lastToastTs = now;
      _lastToastKey = dedupeKey;

      var msg = maxQty > 0
        ? 'Only ' + maxQty + ' in stock for this item.'
        : 'This item is currently out of stock.';
      if (typeof window.ddToast === 'function') {
        window.ddToast(msg, 'warn');
      } else if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
        window.T4SThemeSP.Notices(msg, 'warning');
      }
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var incBtn = target.closest('[data-quantity-selector][data-increase-qty], [data-increase-qty]');
      if (!incBtn || !inCartContext(incBtn)) return;

      var wrapper = incBtn.closest('[data-quantity-wrapper]');
      if (!wrapper) return;
      var input = wrapper.querySelector('[data-quantity-value]');
      if (!input) return;

      var maxQty = toInt(input.getAttribute('max'));
      if (!maxQty || maxQty >= 9999) return;
      var curQty = toInt(input.value);
      if (curQty >= maxQty) {
        showStockLimitToast(maxQty, input.getAttribute('data-id') || input.name || 'cart-stock-click');
      }
    }, true);

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches) return;
      if (!input.matches('[data-quantity-value]')) return;
      if (!inCartContext(input)) return;

      var maxQty = toInt(input.getAttribute('max'));
      if (!maxQty || maxQty >= 9999) return;
      var enteredQty = toInt(input.value);
      if (enteredQty > maxQty) {
        showStockLimitToast(maxQty, input.getAttribute('data-id') || input.name || 'cart-stock-change');
      }
    }, true);
  }

  function init() {
    openCartDrawerAfterSuccess();
    skeletonWatchdog();
    stockLimitToastGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
